import { AxiosInstance } from 'axios';
import {
  AuthzAssignmentUser,
  AuthzCatalog,
  AuthzEngineMode,
  AuthzEngineModeInfo,
  AuthzExplainQuery,
  AuthzExplainResponse,
  AuthzShadowReport,
} from '../../types';

export function createAuthzApi(client: AxiosInstance) {
  return {
    async getEngineMode() {
      const response = await client.get('/authz/engine-mode');
      return response.data as AuthzEngineModeInfo;
    },
    async setEngineMode(mode: AuthzEngineMode, reason: string) {
      const response = await client.put('/authz/engine-mode', { mode, reason });
      return response.data as { previous: AuthzEngineMode; current: AuthzEngineMode };
    },
    async getShadowReport(engine: 'legacy' | 'new' | 'all' = 'legacy', limit = 200) {
      const response = await client.get('/authz/shadow', { params: { engine, limit } });
      return response.data as AuthzShadowReport;
    },
    async getCatalog() {
      const response = await client.get('/authz/catalog');
      return response.data as AuthzCatalog;
    },
    async listAssignments() {
      const response = await client.get('/authz/assignments');
      return response.data as { users: AuthzAssignmentUser[] };
    },
    async setAssignment(userId: number, templateKey: string) {
      const response = await client.put(`/authz/users/${userId}/assignment`, { template_key: templateKey });
      return response.data as { assignment: { id: number; role_profile_code: string; assigned_at: string } };
    },
    async explain(userId: number, query: AuthzExplainQuery) {
      const response = await client.get(`/authz/users/${userId}/explain`, { params: query });
      return response.data as AuthzExplainResponse;
    },
  };
}

export type AuthzApi = ReturnType<typeof createAuthzApi>;
